

import React from "react";
import Slider from "react-slick";
import image from "../images/ayush-mantralaya.webp";
import image1 from "../images/azadi-ka-amrit-mahotsav-hindi-logo-1BE5E3568C-seeklogo.com.png";
import image2 from "../images/mygov.webp";
import image3 from "../images/GMP.webp";
import image4 from "../images/swachh-bharat-abhiyan.webp";
import image5 from "../images/who.webp";

const BrandCarousel = () => {
  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: true, // Add autoplay to make it more dynamic
    autoplaySpeed: 3000, // Set speed for autoplay
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  const images = [image, image1, image2, image3, image4, image5];

  return (
    <div className="bg-gradient-to-r from-blue-50 to-blue-100 py-10 px-8">
      <h2 className="text-center text-2xl font-semibold text-gray-800 mb-6">Our Esteemed Partners</h2>
      <Slider {...sliderSettings}>
        {images.map((img, index) => (
          <div key={index} className="p-4 flex justify-center">
            <div className="relative overflow-hidden rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 ease-in-out">
              <img
                src={img}
                alt={`Brand ${index + 1}`}
                className="w-full h-40 md:h-48 object-fit transform transition-transform duration-300 ease-in-out hover:scale-105"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default BrandCarousel;
